import * as React from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import styles from './buttons.module.css'
import { observable } from 'mobx'

const swipeRightImg = require('../../common/icons/swipe-right.svg')
const swipeLeftImg = require('../../common/icons/swipe-left.svg')
const buttonTooltipCloseImg = require('../icons/icon-schliessen.svg')

interface ButtonProp extends React.HTMLAttributes<HTMLAnchorElement> {
  to?: string
  onClick?: (e: any) => void

  buttonStyle?: string

  children?: React.ReactNode

  isExternal?: boolean
  disabled?: boolean
}

class Button extends React.Component<ButtonProp> {
  render () {

    const s = classnames(this.props.buttonStyle, this.props.className, styles.button, this.props.disabled ? styles.disabled : undefined)
    if (this.props.to) {
      if (this.props.isExternal) {
        return <a href={this.props.to} target='_blank' className={s}> {this.props.children} </a>
      }
      return <Link to={this.props.to} className={s}> {this.props.children} </Link>
    } else {
      return <div className={s} onClick={this.props.onClick} > {this.props.children} </div>

    }
  }
}

export class LesenButton extends React.Component<ButtonProp> {
  @observable hoverButton = false

  render () {
    return (
      <Button {...this.props} buttonStyle={classnames(styles.buttonLesen, this.hoverButton ? styles.buttonLesenScaleup : styles.buttonLesenScaledown)}>
        {this.props.children}
        <div className={styles.lesenText} onMouseEnter={() => this.hoverButton = true} onMouseLeave={() => this.hoverButton = false}>Lesen</div>
      </Button>
    )
  }
}

export class StartButton extends React.Component<ButtonProp> {
  @observable hoverButton = false
  render () {
    return (
      <Button {...this.props} buttonStyle={classnames(styles.buttonLesen, this.hoverButton ? styles.buttonLesenScaleup : styles.buttonLesenScaledown)}>
        {this.props.children}
        <div className={styles.lesenText} onMouseEnter={() => this.hoverButton = true} onMouseLeave={() => this.hoverButton = false}>Start</div>
      </Button>
    )
  }
}

export class PlayButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonPlay}></Button>
    )
  }
}

export class MenuButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonMenu}></Button>
    )
  }
}

export class MenuCloseButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonMenuClose}></Button>
    )
  }
}

export class CloseButtonWhite extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.closeButtonWhite}></Button>
    )
  }
}

export class CloseButtonOrange extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.closeButtonOrange}></Button>
    )
  }
}

export class ImprintButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonImprint}>
        <div className={styles.imprintImg}/>{this.props.children}</Button>
    )
  }
}

export class TestUebungButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonTestUebung}>Uebung Overlay</Button>
    )
  }
}

export class SwipeRightButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonSwipeRight}>
        <img src={swipeRightImg} alt='swipe-right'/>
      </Button>
    )
  }
}

export class SwipeLeftButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonSwipeLeft}>
        <img src={swipeLeftImg} alt='swipe-left'/>
      </Button>
    )
  }
}

export class NotizenMarkerButton extends React.Component<ButtonProp> {
  render () {
    return (
      <div className={styles.buttonNotizenMarker}>
        <Button {...this.props} buttonStyle={styles.buttonNotizen} ></Button>
        <div className={styles.divider}/>
        <Button {...this.props} buttonStyle={styles.buttonMarker}></Button>
      </div>
    )
  }
}

export class TooltipCloseButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonTooltipClose}>
        <img src={buttonTooltipCloseImg} alt='tooltip-close-btn'/>
      </Button>
    )
  }
}
